import React from 'react'
import { FlippingPanel } from '../components'

export function displayFlipPanels() {
  return Array.from({ length: 8 }).map((_, index) => (
    <FlippingPanel 
      key={index} 
      frontPhoto={`/img/Before${index + 1}.jpg`} 
      backPhoto={`/img/After${index + 1}.jpg`} 
    />
  ))
}

export function textWithNewLine(translation) {
  return translation.split('\n').map((item, key) => {
    return <span key={key} data-testid='new-line-text'>{item}<br/></span>
  });
}